import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Topbar from "./Topbar";
import FaqSection from "../common/faq-section/FaqSection";
import DataFetcher from "./DataFetcher";
import { useGeneralSetting } from "../context/GeneralSettingContext";
import Loader from "./Loader";

const Layout = ({ children }) => {
  const location = useLocation();

  const { loading, showLoader, hideLoader } = useGeneralSetting();

  const shouldHideLayout = location.pathname.startsWith("/apply");

  useEffect(() => {
    showLoader();

    const minTime = 1500; // minimum loader time (UX smooth)
    const start = Date.now();

    const timer = setTimeout(() => {
      const elapsed = Date.now() - start;

      if (elapsed >= minTime) {
        hideLoader();
      } else {
        setTimeout(() => hideLoader(), minTime - elapsed);
      }
    }, 500); // small delay for route transition

    return () => clearTimeout(timer);
  }, [location.pathname]);
  return (
    <div>
      {loading && <Loader />}

      <DataFetcher />
      <Topbar />
      {!shouldHideLayout && <Header />}

      {children}

      {!shouldHideLayout && <FaqSection />}
      {!shouldHideLayout && <Footer />}
    </div>
  );
};

export default Layout;
